import { OnInit, Injectable } from '@angular/core';
import { EventsService } from '../events/events.service';

@Injectable()
export class AlertService implements OnInit {
  public alertData: any;

  constructor(public eventsService: EventsService) {
    this.alertData = {};
  }

  createAlert(infoMessage, errorMessage, messageText) {
    this.alertData.infoMessage = infoMessage;
    this.alertData.errorMessage = errorMessage;
    this.alertData.messageText = messageText;
    this.eventsService.broadcast('showAlert', this.alertData);
  }

  ngOnInit() {
   }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/alerts/alerts.service.ts